import { render } from "./Linkdin.vue?vue&type=template&id=b893408c"
import script from "./Linkdin.vue?vue&type=script&lang=js"
export * from "./Linkdin.vue?vue&type=script&lang=js"

import exportComponent from "/chi/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__